import Modal from "shared/Components/modal";

export function EditEntriesModal({ modalRef, children }) {
  return (
    <Modal
      extraClass={`pt-0`}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={modalRef}
    >
        <div className="p-8 pb-0 items-center m-auto w-[350px]">
          {children}
        </div>
    </Modal>
  );
}
